import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../../../utils';
import { RequiredIndicator } from '../../RequiredIndicator';
import styles from './styles.module.scss';

export type FormGroupProps = HTMLAttributes<HTMLDivElement> & {
  fieldId: string;
  label: string;
  errorMessage?: string;
  hideErrorMessage?: boolean;
  hideLabel?: boolean;
  isRequired?: boolean;
};

/**
 * @deprecated since 10/12/2020
 */
export const FormGroup = ({
  children,
  fieldId,
  label,
  errorMessage = '',
  hideErrorMessage = false,
  hideLabel = false,
  isRequired = false,
}: FormGroupProps) => (
  <div className={`${styles.formGroup} ${errorMessage ? styles.hasError : ''}`}>
    <label htmlFor={fieldId} className={joinClassNames(styles.label, hideLabel && styles.hidden)}>
      {label}
      {isRequired && <RequiredIndicator />}
    </label>
    {children}
    {errorMessage && !hideErrorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
  </div>
);
